import(/* webpackMode: "eager" */ "/src/src/app/kebijakan-privasi/page.tsx");
